<template>
  <div class="magic-login-list">
    <div class="login" v-for="l in logins" :key="l.id">
      <span class="time" @click="gotoUser(l.source_user_id)">{{
        createdAt(l)
      }}</span>
      <span style="padding: 0 5px">
        <i v-if="l.source === 'sms'" class="fa fa-phone has-text-link" />
        <i v-if="l.source === 'line'" class="fab fa-line has-text-success" />
      </span>
      <!-- <span class="tag is-medium is-warning has-text-weight-medium">{{
          l.first_code
        }}</span> -->
      <span
        v-if="l.source === 'sms'"
        class="tag is-medium is-dark monospace"
        @click="copyMobile(l)"
        >{{ l.source_user_id }}</span
      >
      <a class="tag is-medium is-warning sms" :href="smsLink(l)">
        {{ l.first_code }}
      </a>
      <span v-if="l.source === 'line'" class="tag is-medium is-success">{{
        l.second_code
      }}</span>

      <span class="is-pulled-right">
        <i
          v-if="l.state === 'initiated'"
          class="fa fa-spinner fa-spin has-text-danger"
        />
        <i v-else class="fa fa-thumbs-up has-text-success" />
      </span>
    </div>

    <div class="has-text-centered" style="padding: 16px">
      <i v-if="loading" class="fa fa-cog fa-spin fa-8x has-text-primary" />
      <span
        v-else
        class="button is-primary is-outlined is-rounded"
        @click="getMagicLogins"
        >Update</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "MagicLoginList",
  data() {
    return {
      logins: [],
      loading: false,
    };
  },
  mounted() {
    this.getMagicLogins();
  },
  methods: {
    gotoUser(phoneNumber) {
      if (phoneNumber.startsWith("+")) this.goto(`/user_info/${phoneNumber}`);
    },
    getMagicLogins() {
      this.loading = true;
      this.$store
        .dispatch("getMagicLogins")
        .then((res) => {
          this.logins = res;
          console.log("magicLogins", res);
        })
        .catch((err) => this.apiError(err))
        .finally(() => (this.loading = false));
    },
    createdAt(l) {
      return new Date(l.created_at).toLocaleTimeString("en-GB");
    },
    copyMobile(l) {
      this.$copyText(l.source_user_id);
      this.successToast(`Copied ` + l.source_user_id, "top");
    },
    smsLink(l) {
      // if (l.source !== "sms") {
      //   return this.warningToast("Not an SMS login");
      // }
      // var href = `sms:${l.source_user_id}&body=TUK App login code: ${l.first_code}`;
      var href = `sms:${l.source_user_id}?body=TUK%20App%20login%20code%3A%20${l.first_code}`;
      return href;
    },
  },
};
</script>

<style scoped>
.magic-login-list {
  background-color: #222;
  height: 100%;
  text-align: left;
}
.time {
  color: #999;
}
.tag {
  padding: 0 5px;
}
.login::-webkit-scrollbar {
  display: none;
}
.login {
  padding: 8px 8px;
  border: 1px solid #333;
  margin-bottom: -1px;
  white-space: nowrap;
  overflow: auto;
}
.sms {
  text-decoration: none !important;
  font-weight: 500;
}
</style>